<template>
  <div class="page">
    <toolbar-system></toolbar-system>
    <progress-system :isLoad="system.progress"></progress-system>
    <alertbar-system v-if="system.AlertbarShow != null" :alertbar="system.AlertbarShow"></alertbar-system>
    <v-container v-show="novoForumView">
      <v-layout>
        <v-flex>
          <v-card>
            <v-card-title>
              <h1 class="display-1 text-uppercase">Gestão de Fórum</h1>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form>
                <v-text-field v-model="forum.topico" color="blue" label="Tópico"></v-text-field>
                <v-checkbox v-model="forum.ativo" color="blue" label="Ativo"></v-checkbox>
                  <v-layout row>
                      <v-flex  sm12 md12 v-show="!forum.ativo">
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="forum.datainicio"
                                label="Data de abertura do fórum"
                                readonly
                                v-on="on"
                                color="blue"
                              ></v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" color="blue" v-model="forum.datainicio" @input="menu = false"></v-date-picker>
                          </v-menu>
                      </v-flex>
                      <v-flex sm12 md12>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                  label="Data de fechamento do fórum (Opcional)"
                                  v-model="forum.datafim"
                                  readonly
                                  v-on="on"
                                  color="blue"
                                ></v-text-field>
                            </template>
                            <v-date-picker locale="pt-br" color="blue" v-model="forum.datafim" @input="menu2 = false"></v-date-picker>
                          </v-menu>
                      </v-flex>
                  </v-layout>

                  <v-radio-group @click="getCursos()" v-model="verificaTurma">
                      <v-radio color="blue" label="Geral" value="geral"></v-radio>
                      <v-radio color="blue" label="Turma" value="turma"></v-radio>
                  </v-radio-group>
                  <v-select v-model="forum.IdTurma" :items="cursos" item-text="TurmaDescricao" item-value="IdTurma" :loading="loadCursos == null ? true : false" v-show="verificaTurma == 'turma'" color="blue" label="Selecione a turma"></v-select>
                <v-textarea v-model="forum.descricao" label="Descrição" color="blue"></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="[novoForumView = false, btnForumEditar = false]" class="siler" large dark>Cancelar</v-btn>
              <v-btn v-if="btnForumEditar" @click="atualizarForum(forum.id)" class="blue darken-1" large dark>Atualizar</v-btn>
              <v-btn v-else @click="createForum()" class="blue darken-1" large dark>Enviar</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
        <v-layout>
            <v-flex xl12>
                <v-card flat>
                    <v-card-title>
                        <v-autocomplete
                            color="blue"
                            label="Fóruns"
                            :items="foruns"
                            item-text="Topico"
                            item-value="IdForum"
                            prepend-icon="mdi mdi-database-search"
                            @change="getForumSearch($event)"
                        ></v-autocomplete>

                        <v-btn
                            dark
                            color="blue"
                            @click="novoForumView = !novoForumView"
                        >
                            <v-icon left>mdi mdi-plus</v-icon>Novo Fórum
                        </v-btn>
                    </v-card-title>
                <v-card-text>
                <v-list>
                    <template v-for="forum in foruns">
                        <v-list-tile :key="forum.index" :id="forum.IdForum">
                            <v-list-tile-action>
                                <v-chip v-if="forum.Ativo == 1" color="blue" outline>Ativo</v-chip>
                                <v-chip v-else color="orange" outline>Desativado</v-chip>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                {{forum.Topico}}
                             </v-list-tile-content>
                             <v-list-tile-action>
                                <v-btn @click="[interacoesForum(forum.IdForum), dialogInteracoes = true]" color="green" dark icon>
                                    <v-icon>mdi mdi-forum</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-action>
                                <v-btn @click="[editarForum(forum.IdForum), novoForumView = true, btnForumEditar = true]" color="orange" dark icon>
                                    <v-icon>mdi mdi-pencil</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-action>
                                <v-btn @click="deleteForum(forum.IdForum)" color="red" dark icon>
                                    <v-icon>mdi mdi-delete</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider :key="forum.index"></v-divider>
                    </template>
                </v-list>
                </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
      <v-dialog v-model="dialogInteracoes" max-width="800">
        <v-card v-if="relInteracoes != null">
          <v-card-title class="headline">{{relInteracoes.Topico}}</v-card-title>

          <v-card-text>
            {{relInteracoes.Descricao}}
          </v-card-text>

          <v-card-text>
            <h4>Respostas</h4>
            <!-- <v-list>
              <v-list-tile v-for="respostas in forumRespostas" :key="respostas.index">
                <v-list-tile-content> -->
                  <v-card class="ma-2 pa-2 grey lighten-5" v-for="respostas in forumRespostas" :key="respostas.index">
                    <v-card-title>
                      <h4>{{respostas.UsuarioResposta}}</h4>
                    </v-card-title>
                    <v-card-text>
                      {{respostas.Texto}}
                    </v-card-text>
                  </v-card>
                <!-- </v-list-tile-content>
              </v-list-tile>
            </v-list> -->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click="dialogInteracoes = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'



  export default{
    components:{
      ToolbarSystem,
      ProgressSystem,
      AlertbarSystem
    },
    data(){
      return{
        system:{
          progress: true,
          AlertbarShow: null,
          due: null
        },
        menu: false,
        modal: false,
        menu2: false,
        dialogInteracoes: false,
        relInteracoes: null,
        forumRespostas: [],
        date: new Date().toISOString().substr(0, 10),
        forum:{
          topico: null,
          ativo: true,
          descricao: null,
          IdTurma: null,
          datainicio: null,
          datafim: null
        },
        aviso:{
            curso: null,
            titulo: null,
            texto: null
        },
        verificaTurma: null,
        cursos: null,
        tituloCurso: "",
        loadCursos: null,
        novoForumView: false,
        btnForumEditar: false,
        foruns: null
      }
    },
    methods:{
      getForuns(){
        this.axios.get('admin/foruns').then(res => {
          this.foruns = res.data
        }).finally(() =>{
          this.system.progress = false
        })
      },
      getCursos(){
          if(this.verificaTurma == 'geral'){
              this.forum.IdTurma = null
              this.axios.get('/user/foruns/turmas').then(res => {
                  this.cursos = res.data
              }).finally(() =>{
                  this.loadCursos = false
              })
          }else{
              this.forum.IdTurma = null
              this.axios.get('/user/foruns/turmas').then(res => {
                  this.cursos = res.data
              }).finally(() =>{
                  this.loadCursos = false
              })
          }
      },
      createForum(){
        this.system.progress = true
        this.axios.post('admin/foruns', this.forum).then(res => {
            this.novoForumView = false
            this.forum.topico = null
            this.aviso.IdTurma = null
            this.forum.descricao = null
            this.forum.datainicio = null
            this.forum.datafim = null



          this.system.AlertbarShow = {
              color: 'green',
              show: true,
              time: 10000,
              text: res.data,
              bottom: false,
              right: true,
              multi: true
          }
          this.getForuns()
        }).catch(e => {
          this.system.AlertbarShow = {
              color: 'red',
              show: true,
              time: 10000,
              text: e.response.data,
              bottom: false,
              right: true,
              multi: true
          }
        }).finally(() =>{
          this.system.progress = false
        })
      },
      editarForum(idForum){
        this.novoForumView = true
        // this.btnForumEditar = true

        this.foruns.map(elem => {
            if(elem.IdForum == idForum){
                this.forum.id = elem.IdForum
                this.forum.topico = elem.Topico
                this.forum.descricao = elem.Descricao
                this.forum.ativo = elem.Ativo
                this.forum.IdTurma = elem.IdTurma
                this.forum.datainicio = elem.DataInicio
                this.forum.datafim = elem.DataFim
            }
        })
      },
      atualizarForum(idForum){
        this.system.progress = true
        this.axios.put(`admin/foruns/${idForum}`, this.forum).then(res => {
          this.novoForumView = false
          this.forum.topico = null
          this.forum.descricao = null
          this.forum.IdTurma = null
          this.forum.datainicio = null
          this.forum.datafim = null
          this.system.AlertbarShow = {
              color: 'green',
              show: true,
              time: 10000,
              text: res.data,
              bottom: false,
              right: true,
              multi: true
          }
          this.getForuns()
        }).catch(e => {
          this.system.AlertbarShow = {
              color: 'red',
              show: true,
              time: 10000,
              text: e.response.data,
              bottom: false,
              right: true,
              multi: true
          }
        }).finally(() =>{
          this.system.progress = false
        })
      },
      deleteForum (idForum){
        let con = confirm("Deseja realmente excluir esse fórum?")
          if(con){
              this.axios.delete(`admin/foruns/${idForum}`).then(res => {
                  this.system.AlertbarShow = {
                      color: 'green',
                      show: true,
                      time: 10000,
                      text: res.data,
                      bottom: false,
                      right: true,
                      multi: true
                  }
                  this.getForuns()
              }).catch(e => {
                  this.system.AlertbarShow = {
                      color: 'red',
                      show: true,
                      time: 10000,
                      text: e.response.data,
                      bottom: false,
                      right: true,
                      multi: true
                  }
              }).finally(() =>{
                  this.system.progress = false
              })
          }
      },
      interacoesForum (IdForum) {
        // Comportamento inesperado que não compromete o funcionamento
        // Rever a API e as permissões
        this.axios.get(`admin/foruns/${IdForum}`).then(res => {
          this.relInteracoes = res.data[0]
        }).catch(() => {
          // alert(e)
        })

        // forumRespostas
        this.axios.get(`admin/foruns/${IdForum}/respostas`).then(res => {
          this.forumRespostas = res.data
        }).catch(() => {
          // alert(e)
        })
      }
    },
    mounted(){
      this.getForuns()
    }
  }

</script>
